// 
import WebComponent from '../webComponents/WebComponent';

export default class PrintPage extends WebComponent {
	didMount() {
    let {
       target,
    } = this.props;

    if (typeof(target) == 'undefined') {
      target = this.element.href;
    }

    let ifrm = document.getElementById('printPage');

    this.on('click', (e) => {
      if (ifrm) {
        ifrm.remove();
      }
      ifrm = document.createElement('frame');
      ifrm.setAttribute('src', target);
      ifrm.setAttribute('id', 'printPage');
      ifrm.setAttribute('name', 'printPage');
      ifrm.style.width = '0';
      ifrm.style.height = '0';
      document.body.appendChild(ifrm);
      window.setTimeout(this.printFrame, 1000);
      e.preventDefault();
    });
	}
	printFrame() {
    window.frames['printPage'].print();
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/PrintPage.js